export default "__VITE_ASSET__b331e097__"